import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class ManualApiService extends ApiService {
  readonly resourcePath = 'manuals';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  getBySlug(slug: string): Observable<any> {
    return this.http.get(this.apiUrl+'/manual_slug/'+ slug);
  }

  search(id: string, query:string): Observable<any> {
    return this.http.get(this.apiUrl+'/knowledge-base/manuals/'+id+'/search?query='+ query);
  }
}
